import { __awaiter, __generator } from '../node_modules/tslib/tslib.es6.js';
import md5 from 'js-md5';

var fingerprint = function () { return __awaiter(void 0, void 0, void 0, function () {
    var navigatorInfo, screenInfo, windowInfo, otherInfo, fingerprintString;
    return __generator(this, function (_a) {
        try {
            navigatorInfo = {
                userAgent: navigator.userAgent,
                platform: navigator.platform,
                language: navigator.language,
                online: navigator.onLine,
                vendor: navigator.vendor,
                maxTouchPoints: navigator.maxTouchPoints,
                hardwareConcurrency: navigator.hardwareConcurrency,
                appName: navigator.appName,
                appVersion: navigator.appVersion,
                product: navigator.product,
                languages: navigator.languages,
                onLine: navigator.onLine,
                geolocation: navigator.geolocation,
            };
            screenInfo = {
                width: screen.width,
                height: screen.height,
                availWidth: screen.availWidth,
                availHeight: screen.availHeight,
                colorDepth: screen.colorDepth,
                pixelDepth: screen.pixelDepth,
                angle: screen.orientation.angle,
                type: screen.orientation.type,
            };
            windowInfo = {
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
                outerWidth: window.outerWidth,
                outerHeight: window.outerHeight,
            };
            otherInfo = {
                time: new Date().getTime()
            };
            fingerprintString = JSON.stringify({
                navigator: navigatorInfo,
                screen: screenInfo,
                window: windowInfo,
                other: otherInfo
            });
            return [2 /*return*/, md5(fingerprintString)];
        }
        catch (error) {
            console.error('Error generating fingerprint:', error);
            return [2 /*return*/, null];
        }
        return [2 /*return*/];
    });
}); };

export { fingerprint };
